export default __webpack_public_path__ + "static/media/appStore_download_hover.988b77b3.svg";